import {
  getOptionFromOptionName,
  getOptionValueFromValueName,
} from '../usePDPPhotos/utils';

export const getAllPreconfigHeroImages = ({
  preConfiguredProducts = [],
  options = [],
}) => {
  if (!preConfiguredProducts?.length || !options?.length) return [];
  let finalGallery = [];
  let idCount = 0;
  const fabricParentOption = options.find(opt => parseInt(opt.id, 10) === 17);
  const fabricNamesList = fabricParentOption
    ? fabricParentOption.values.map(optVal => optVal.value.trim())
    : [];
  preConfiguredProducts.forEach(preConfigProduct => {
    const gallery =
      preConfigProduct.hero_images && preConfigProduct.hero_images.length
        ? preConfigProduct.hero_images
            .map(heroImage => {
              const {
                img: { url, cropData = {} },
                upholstery_name,
                upholstery_type,
              } = heroImage;
              const option = getOptionFromOptionName(options, upholstery_type);
              const value = getOptionValueFromValueName(
                option,
                upholstery_name
              );
              // Check if fabric is in modular parent
              if (heroImage.upholstery_type === 'Fabric') {
                if (
                  fabricNamesList.length &&
                  !fabricNamesList.includes(heroImage.upholstery_name.trim())
                )
                  return null;
              }
              idCount += 1;
              return {
                product_name: preConfigProduct.name,
                product_id: preConfigProduct.id,
                image_id: idCount,
                type: 'studio',
                src: url,
                id: url,
                cropData,
                upholsteryName: upholstery_name,
                upholsteryType: upholstery_type,
                optionId: option?.id,
                valueId: value?.id,
              };
            })
            .filter(v => !!v)
        : [];
    finalGallery = [...finalGallery, ...gallery];
  });

  return finalGallery;
};

export const findSectionalPreconfiguredProduct = (
  preconfiguredProducts = []
) => {
  if (!preconfiguredProducts.length) return null;

  let sectionalProduct = preconfiguredProducts.filter(product => {
    if (product.type && product.type.name.toLowerCase().includes('sectional')) {
      return true;
    }
    return false;
  });
  // If no sectional product look for modular
  if (!sectionalProduct.length) {
    sectionalProduct = preconfiguredProducts.filter(product => {
      if (product.type && product.type.name.toLowerCase().includes('modular')) {
        return true;
      }
      return false;
    });
  }
  if (sectionalProduct.length) return sectionalProduct[0];
  // If no sectional or modular product found return first preconfig product
  return preconfiguredProducts[0];
};

export const getHeroImagesForProduct = (product, options) => {
  if (!product || !options.length) return [];

  let idCount = 0;
  const fabricParentOption = options.find(opt => parseInt(opt.id, 10) === 17);
  const fabricNamesList = fabricParentOption
    ? fabricParentOption.values.map(optVal => optVal.value.trim())
    : [];
  const gallery = product.hero_images?.length
    ? product.hero_images
        .map(heroImage => {
          const {
            img: { url, cropData = {} },
            upholstery_name,
            upholstery_type,
          } = heroImage;
          const option = getOptionFromOptionName(options, upholstery_type);
          const value = getOptionValueFromValueName(option, upholstery_name);
          // Check if fabric is in modular parent
          if (heroImage.upholstery_type === 'Fabric') {
            if (
              fabricNamesList.length &&
              !fabricNamesList.includes(heroImage.upholstery_name.trim())
            )
              return null;
          }
          idCount += 1;
          return {
            product_name: product.name,
            product_id: product.id,
            image_id: idCount,
            type: 'studio',
            src: url,
            id: url,
            cropData,
            upholsteryName: upholstery_name,
            upholsteryType: upholstery_type,
            optionId: option?.id,
            valueId: value?.id,
          };
        })
        .filter(v => !!v)
    : [];
  return gallery;
};
